const drawer = document.querySelector('.d5-cart-left');
const rightCp = document.querySelector('.cart__right');
function hideCheckoutElement() {
  const elem = document.querySelector('.cp-checkout-d5');
  if (elem) {
    elem.setAttribute('hidden', '');
  } else {
    console.warn('Element .cp-checkout-d5 not found.');
  }
}

function showCheckoutElement() {
  const elem = document.querySelector('.cp-checkout-d5');
  if (elem) {
    elem.removeAttribute('hidden');
  } else {
    console.warn('Element .cp-checkout-d5 not found.');
  }
}

document.addEventListener('click', async e => {
  const minus = e.target.closest('.cd-qty-minus-d5');
  const plus = e.target.closest('.cd-qty-plus-d5');
  if (!minus && !plus) return;
  e.preventDefault();

  const item = e.target.closest('[line-item]');
  if (!item) return;

  const key = item.getAttribute('line-item');
  const input = item.querySelector('.cd-qty-input-d5');
  let qty = parseInt(input.value, 10);

  if (plus) qty++;

  if (minus) {
    if (qty === 1) {
      const modal = item.querySelector('#cp-remove-confirmation-modal-d5');
      const confirmBtn = modal.querySelector('.cp-confirm-remove-d5');

      const moveBtn = modal.querySelector('.cp-move-wishlist-d5');

      const confirmed = await new Promise(resolve => {
        modal.style.display = 'flex';
        confirmBtn.onclick = () => {
          modal.style.display = 'none';
          resolve(true);
        };
       document.addEventListener('click', e => {
          const cancelBtn = e.target.closest('.cp-cancel-d5');
          if (cancelBtn) {
            const modal = cancelBtn.closest('.cp-remove-confirmation-modal-d5');
            if (modal) modal.style.display = 'none';
          }
        });

        moveBtn.onclick = () => {
          setTimeout(() => {
             modal.style.display = 'none';
          resolve(true);
          },300)
        };
      });

      if (!confirmed) return;
      qty = 0;
    } else qty--;
  }

  item.classList.add('loading');
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  await rerender();
});

document.body.addEventListener('click', async function (e) {
  const saveBtn = e.target.closest('.cd-save-later-d5');
  if (!saveBtn) return;
  e.preventDefault();
  const item = saveBtn.closest('[line-item]');
  if (!item) return;
  const key = item.getAttribute('line-item');
  saveBtn.classList.add('loading');
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await rerender();
  } catch (err) {
    console.error(err);
    saveBtn.classList.remove('loading');
  }
});


  let oldVariantQuantity;
  let oldVariantId;
  document.body.addEventListener('click', async function (e) {
  const trigger = e.target.closest('.cd-item-options-d5')
  if (!trigger) return
  e.preventDefault();
  hideCheckoutElement()
  oldVariantId = trigger.getAttribute('variant-id');
  oldVariantQuantity = trigger.getAttribute('data-quantity');
  const modal = document.querySelector('.cd-variant-update-modal-d5')
  const modalInner = modal.querySelector('.cdv-um-inner-d5')
  const url = trigger.dataset.url
  modal.classList.add('active')
  try {
    const response = await fetch(url)
    const html = await response.text()
    const temp = document.createElement('div')
    temp.innerHTML = html
    const mainProduct = temp.querySelector('.main-product-d5')
    temp.querySelector('.mp-update-btn-d5').classList.add('disabled');
    modal.classList.add('loading-nul');
    if (mainProduct) modalInner.appendChild(mainProduct)
  } catch (error) {
    console.error('Error loading variant options:', error)
  }
   document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
})

  document.body.addEventListener("click",function(e){
    const valueEl=e.target.closest(".mp-value-d5");
    if(!valueEl)return;
    const optionWrapper=valueEl.closest(".mp-option-values-d5");
    if(!optionWrapper)return;
    optionWrapper.querySelectorAll(".mp-value-d5").forEach(el=>el.classList.remove("active"));
    valueEl.classList.add("active");
    document.querySelector('.mp-update-btn-d5').classList.add('disabled');
    const productEl=document.querySelector(".mp-product-json-d5");
    if(!productEl)return;
    const productJson=JSON.parse(productEl.textContent);
    const selectedOptions=[];
    document.querySelectorAll(".mp-option-values-d5").forEach(group=>{
      const active=group.querySelector(".mp-value-d5.active");
      if(active)selectedOptions.push(active.textContent.trim());
    });
    const matchedVariant=productJson.variants.find(v=>v.options.every((opt,i)=>opt===selectedOptions[i]));
    if(matchedVariant){
      const mainProduct=document.querySelector(".main-product-d5");
      if(mainProduct){
        const url=mainProduct.getAttribute("data-url");
        fetch(`${url}&variant=${matchedVariant.id}`)
        .then(res=>res.text())
        .then(html=>{
          const temp=document.createElement("div");
          temp.innerHTML=html;
          const newInfo=temp.querySelector(".mp-product-info-d5");
          const oldInfo=document.querySelector(".mp-product-info-d5");
          const btn = temp.querySelector('.mp-update-btn-d5')
          if(oldVariantId == btn.getAttribute('data-variant')){
            btn.classList.add('disabled');
            // btn.textContent = 'Already in Cart'
          }
          if(newInfo&&oldInfo)oldInfo.innerHTML=newInfo.innerHTML;
            document.querySelectorAll('.wishlist-button-d5').forEach(button => {
              updateWishlistState(button);
            });
        });
      }
    }
  });

document.body.addEventListener('click', async function (e) {
  const link = e.target.closest('.mp-color-switch-link-d5');
  if (!link) return;
  e.preventDefault();
  const modal = link.closest('.cd-variant-update-modal-d5, .quick-add-modal-d5, .cart-add-modal-d5');
  if (!modal) return;
  const modalInner = modal.querySelector('.cdv-um-inner-d5, .qa-inner-d5');
  if (!modalInner) return;
  const url = link.dataset.url;
  try {
    const response = await fetch(url);
    const html = await response.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const mainProduct = temp.querySelector('.main-product-d5');
    if (mainProduct) {
      const oldMainProduct = modalInner.querySelector('.main-product-d5');
      if (oldMainProduct) oldMainProduct.remove();
      modalInner.appendChild(mainProduct);
    }
  } catch (error) {
    console.error('Error switching color:', error);
  }
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const updateBtn = e.target.closest('#cart-drawer-d5 .mp-update-btn-d5');
  if (!updateBtn || updateBtn.classList.contains('disabled')) return;
  e.preventDefault();
  const newVariantId = updateBtn.getAttribute('data-variant');
  if (!oldVariantId || !newVariantId || oldVariantId === newVariantId) return;
  const modal = document.querySelector('.cd-variant-update-modal-d5');
  closeModal(select = '.cd-variant-update-modal-d5');
  drawer.classList.add('atc-loading-d5');
  setTimeout(() => {
     drawer.classList.add('active');
  }, 200);
  const qty = oldVariantQuantity ? oldVariantQuantity : 1
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: oldVariantId, quantity: 0 })
    });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: newVariantId, quantity: qty })
    });
    await rerender();
    modal.classList.remove('active');
  } catch (error) {
    console.error('Error updating variant:', error);
  } finally {
    drawer.classList.remove('atc-loading-d5');
  }
});

function closeModal(select) {
  const modal = document.querySelector(select);
  const appendedSection = modal.querySelector('.main-product-d5');
  if (appendedSection) appendedSection.remove();
  modal.classList.remove('active', 'loading-nul');
  showCheckoutElement();
}

document.body.addEventListener("click", function (e) {
  if (e.target.hasAttribute('close-update-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
  }
  if (e.target.hasAttribute('qa-close-modal-d5')) {
    e.preventDefault();
    closeModal(select = '.cd-variant-update-modal-d5');
    closeModal(select = '.cart-add-modal-d5 .qa-inner-d5');
    document.querySelector('.quick-add-modal-d5').classList.remove('active', 'loading-nul');
    document.querySelector('.cart-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});


 window.rerender = async function () {
  const res = await fetch('/cart');
  const text = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const emptyCart = doc.querySelector('[render-empty-cart]');
  const emptyCon = document.querySelector('.empty-cart-d5')
  if(emptyCart && emptyCon){
    emptyCon.innerHTML = emptyCart.innerHTML

}else {
   const newElems = doc.querySelectorAll('[cp-render-d5]');
  const currentElems = document.querySelectorAll('[cp-render-d5]');
  const oldCount = document.querySelector('.cart-count-d5');
  const newCount = doc.querySelector('.cart-count-d5');
  if(oldCount && newCount){
    oldCount.innerHTML = newCount.innerHTML;
  }
  currentElems.forEach((el, i) => {
    const newEl = newElems[i];
    if (newEl) el.innerHTML = newEl.innerHTML;
  });
}
  document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
};
// const cpOpener = document.querySelector('.cp-mob-total-d5');



document.body.addEventListener('click', e =>{
  if(e.target.classList.contains('cp-mob-total-d5')){
    e.preventDefault();
    rightCp.classList.add('active');
  }
  if(e.target.hasAttribute('cr-close-d5')){
    e.preventDefault();
    rightCp.classList.remove('active');
  }
})
function applyDiscountCode() {
  const discountBar = document.querySelectorAll('.discount-field-d5');
  discountBar.forEach(bar => {
    const discountInput = bar.querySelector(".discount-input-d5");
    const appliedDiscounts = bar.querySelector(".applied-discounts-d5");
    const failedDiscounts = bar.querySelector(".failed-discounts-d5");
    document.body.addEventListener("click", function(event) {
      if (event.target.classList.contains("discount-button-d5")) {
        event.preventDefault();
        event.target.classList.add('loading');

        const discountCode = discountInput.value.trim();

        if (discountCode) {
          fetch(`/discount/${discountCode}`)
            .then(data => {
              fetch('/cart')
                .then(cartResponse => cartResponse.text())
                .then(cartHTML => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(cartHTML, 'text/html');
                  const lis = doc.querySelectorAll('.applied-discounts-d5 li');
                  lis.forEach(l => {
                    if (l.dataset.code == discountCode) {
                      const newElem = doc.querySelectorAll('[discount-render-d5]');
                      const oldElem = document.querySelectorAll('[discount-render-d5]');
                      oldElem.forEach((elem, index) => {
                        elem.innerHTML = newElem[index].innerHTML;
                      });
                    } else {
                      failedDiscounts.classList.add('active');
                    }
                  });
                })
                .catch(cartError => {
                  console.error('Error fetching cart:', cartError);
                });
            })
            .catch(discountError => {
              console.error('Error applying discount:');
            }).finally(() => {
              event.target.classList.remove('loading');
            })
            event.target.classList.add('loading');
        } else {
          event.target.classList.remove('loading');
        }
      }
    });
  });
}


applyDiscountCode()

document.addEventListener('click',async function(e){
  const el=e.target.closest('.pc-product-add-btn-d5');
  const modal = document.querySelector('.cart-add-modal-d5');
  if(!el)return;
  e.preventDefault();
  const url=el.getAttribute('data-url');
  hideCheckoutElement()
  if(!url)return;
  modal.classList.add('active');
  try{
    const response=await fetch(url);
    if(!response.ok)throw new Error();
    const htmlText=await response.text();
    const parser=new DOMParser();
    const doc=parser.parseFromString(htmlText,'text/html');
    const productContent=doc.querySelector('.main-product-d5');
    if(!productContent)return;
    const targetContainer=modal.querySelector('.qa-inner-d5');
    if(!targetContainer)return;
    targetContainer.appendChild(productContent);
    modal.classList.add('loading-nul');
  }catch(err){
    console.error(err);
  }
   document.querySelectorAll('.wishlist-button-d5').forEach(button => {
    updateWishlistState(button);
  });
});

document.body.addEventListener('click', async function (e) {
  const button = e.target.closest('.cart-add-modal-d5 .atc-btn-d5');
  if(!button) return null;
  const variantId = button.getAttribute('data-variant');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  button.classList.add('disabled')

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    });
    const data = await res.json();
    await rerender(data.key);
  } catch (err) {
    console.error(err);
  }finally{
    closeModal(select = '.cart-add-modal-d5 .qa-inner-d5');
    document.querySelector('.cart-add-modal-d5').classList.remove('active', 'loading-nul');
  }
});

document.body.addEventListener('click', (e) => {
  if(e.target.classList.contains('final-item-opener-d5')){
    e.preventDefault();
    document.querySelector('.final-item-modal-d5').classList.add('active');
    hideCheckoutElement()

  }
  if(e.target.hasAttribute('fi-close-d5')){
    e.preventDefault();
    showCheckoutElement();
    document.querySelector('.final-item-modal-d5').classList.remove('active');
  }
})